import {ChangeDetectorRef, Component, DestroyRef, inject, OnInit, ViewEncapsulation} from '@angular/core';
import { NutritionFacadeService } from '@emm/management/services/nutrition-facade.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {NutritionAssignment} from '@emm/core/models/nutrition.model';
import {distinctUntilChanged} from 'rxjs/operators';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-nutrition-assignments-list',
    styleUrls: ['./nutrition-assignments-list.component.scss'],
    templateUrl: './nutrition-assignments-list.component.html'
})
export class NutritionAssignmentsListComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    assignments: NutritionAssignment[];
    assignments$ = this.nutritionFacade.assignments$;
    locationTag: string;
    selectedAssignment: number;

    constructor(public nutritionFacade: NutritionFacadeService,
                private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        this.nutritionFacade.location$
            .pipe(
                distinctUntilChanged(),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(location => {
            if (!location) {
                this.selectedAssignment = null;
            } else {
                this.nutritionFacade.selectedLocationSet(location);
                this.locationTag = location.tag;
                this.nutritionFacade.loadAssignments();
            }
        });
        this.nutritionFacade.selectedDate$
            .pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(date => {
                this.selectedAssignment = date;
                this.cdr.detectChanges();
        });
    }

    handleClick(assignment): void {
        if (assignment.effectiveDate !== this.selectedAssignment) {
            this.selectedAssignment = assignment;
            this.nutritionFacade.selectedAssignment({
                ...assignment,
                location: this.locationTag
            });
        }
    }
}
